module.exports = __webpack_public_path__ + "static/img/brees-2003-slide-3.e30b74e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2003-slide-3.jpg
// module id = gGf0
// module chunks = 1